export var IconSymbol;
(function (IconSymbol) {
    IconSymbol[IconSymbol["Add"] = 0] = "Add";
    IconSymbol[IconSymbol["Adsr"] = 1] = "Adsr";
    IconSymbol[IconSymbol["ArrowDown"] = 2] = "ArrowDown";
    IconSymbol[IconSymbol["ArrowLeft"] = 3] = "ArrowLeft";
    IconSymbol[IconSymbol["ArrowRight"] = 4] = "ArrowRight";
    IconSymbol[IconSymbol["ArrowUp"] = 5] = "ArrowUp";
    IconSymbol[IconSymbol["AudioBus"] = 6] = "AudioBus";
    IconSymbol[IconSymbol["AudioDevice"] = 7] = "AudioDevice";
    IconSymbol[IconSymbol["AudioFile"] = 8] = "AudioFile";
    IconSymbol[IconSymbol["AutoGain"] = 9] = "AutoGain";
    IconSymbol[IconSymbol["Automation"] = 10] = "Automation";
    IconSymbol[IconSymbol["BassGuitar"] = 11] = "BassGuitar";
    IconSymbol[IconSymbol["Book"] = 12] = "Book";
    IconSymbol[IconSymbol["Box"] = 13] = "Box";
    IconSymbol[IconSymbol["Browse"] = 14] = "Browse";
    IconSymbol[IconSymbol["Bug"] = 15] = "Bug";
    IconSymbol[IconSymbol["Capture"] = 16] = "Capture";
    IconSymbol[IconSymbol["Chain"] = 17] = "Chain";
    IconSymbol[IconSymbol["ChatEmpty"] = 18] = "ChatEmpty";
    IconSymbol[IconSymbol["ChatMessage"] = 19] = "ChatMessage";
    IconSymbol[IconSymbol["Copy"] = 20] = "Copy";
    IconSymbol[IconSymbol["Maximizer"] = 21] = "Maximizer";
    IconSymbol[IconSymbol["Fold"] = 22] = "Fold";
    IconSymbol[IconSymbol["Folder"] = 23] = "Folder";
    IconSymbol[IconSymbol["Charts"] = 24] = "Charts";
    IconSymbol[IconSymbol["Checkbox"] = 25] = "Checkbox";
    IconSymbol[IconSymbol["Clips"] = 26] = "Clips";
    IconSymbol[IconSymbol["Close"] = 27] = "Close";
    IconSymbol[IconSymbol["CloudFolder"] = 28] = "CloudFolder";
    IconSymbol[IconSymbol["Code"] = 29] = "Code";
    IconSymbol[IconSymbol["CollapseDown"] = 30] = "CollapseDown";
    IconSymbol[IconSymbol["Compressor"] = 31] = "Compressor";
    IconSymbol[IconSymbol["Connected"] = 32] = "Connected";
    IconSymbol[IconSymbol["Cube"] = 33] = "Cube";
    IconSymbol[IconSymbol["Cursor"] = 34] = "Cursor";
    IconSymbol[IconSymbol["Curve"] = 35] = "Curve";
    IconSymbol[IconSymbol["Dattorro"] = 36] = "Dattorro";
    IconSymbol[IconSymbol["Delete"] = 37] = "Delete";
    IconSymbol[IconSymbol["Dial"] = 38] = "Dial";
    IconSymbol[IconSymbol["DinSlot"] = 39] = "DinSlot";
    IconSymbol[IconSymbol["Disconnected"] = 40] = "Disconnected";
    IconSymbol[IconSymbol["Divide"] = 41] = "Divide";
    IconSymbol[IconSymbol["DragConnections"] = 42] = "DragConnections";
    IconSymbol[IconSymbol["Dropdown"] = 43] = "Dropdown";
    IconSymbol[IconSymbol["Dropbox"] = 44] = "Dropbox";
    IconSymbol[IconSymbol["DrumSet"] = 45] = "DrumSet";
    IconSymbol[IconSymbol["Tidal"] = 46] = "Tidal";
    IconSymbol[IconSymbol["Duration"] = 47] = "Duration";
    IconSymbol[IconSymbol["EditBox"] = 48] = "EditBox";
    IconSymbol[IconSymbol["Effects"] = 49] = "Effects";
    IconSymbol[IconSymbol["Embed"] = 50] = "Embed";
    IconSymbol[IconSymbol["EQ"] = 51] = "EQ";
    IconSymbol[IconSymbol["Eraser"] = 52] = "Eraser";
    IconSymbol[IconSymbol["Exclude"] = 53] = "Exclude";
    IconSymbol[IconSymbol["Exit"] = 54] = "Exit";
    IconSymbol[IconSymbol["ExpandWidth"] = 55] = "ExpandWidth";
    IconSymbol[IconSymbol["FileList"] = 56] = "FileList";
    IconSymbol[IconSymbol["Film"] = 57] = "Film";
    IconSymbol[IconSymbol["Flask"] = 58] = "Flask";
    IconSymbol[IconSymbol["Focus"] = 59] = "Focus";
    IconSymbol[IconSymbol["Fullscreen"] = 60] = "Fullscreen";
    IconSymbol[IconSymbol["Gate"] = 61] = "Gate";
    IconSymbol[IconSymbol["Generator"] = 62] = "Generator";
    IconSymbol[IconSymbol["GoogleDrive"] = 63] = "GoogleDrive";
    IconSymbol[IconSymbol["Groove"] = 64] = "Groove";
    IconSymbol[IconSymbol["Guitar"] = 65] = "Guitar";
    IconSymbol[IconSymbol["GuitarTab"] = 66] = "GuitarTab";
    IconSymbol[IconSymbol["Headphone"] = 67] = "Headphone";
    IconSymbol[IconSymbol["Heart"] = 68] = "Heart";
    IconSymbol[IconSymbol["Help"] = 69] = "Help";
    IconSymbol[IconSymbol["HighPass"] = 70] = "HighPass";
    IconSymbol[IconSymbol["HighShelf"] = 71] = "HighShelf";
    IconSymbol[IconSymbol["Insert"] = 72] = "Insert";
    IconSymbol[IconSymbol["InsertDown"] = 73] = "InsertDown";
    IconSymbol[IconSymbol["Invert"] = 74] = "Invert";
    IconSymbol[IconSymbol["Info"] = 75] = "Info";
    IconSymbol[IconSymbol["Lock"] = 76] = "Lock";
    IconSymbol[IconSymbol["Loop"] = 77] = "Loop";
    IconSymbol[IconSymbol["LoopEnd"] = 78] = "LoopEnd";
    IconSymbol[IconSymbol["LoopStart"] = 79] = "LoopStart";
    IconSymbol[IconSymbol["LowPass"] = 80] = "LowPass";
    IconSymbol[IconSymbol["LowShelf"] = 81] = "LowShelf";
    IconSymbol[IconSymbol["Magnet"] = 82] = "Magnet";
    IconSymbol[IconSymbol["MainMenu"] = 83] = "MainMenu";
    IconSymbol[IconSymbol["Maximized"] = 84] = "Maximized";
    IconSymbol[IconSymbol["Menu"] = 85] = "Menu";
    IconSymbol[IconSymbol["Merge"] = 86] = "Merge";
    IconSymbol[IconSymbol["Metronome"] = 87] = "Metronome";
    IconSymbol[IconSymbol["Microphone"] = 88] = "Microphone";
    IconSymbol[IconSymbol["Midi"] = 89] = "Midi";
    IconSymbol[IconSymbol["Minimized"] = 90] = "Minimized";
    IconSymbol[IconSymbol["Mix"] = 91] = "Mix";
    IconSymbol[IconSymbol["Mixing"] = 92] = "Mixing";
    IconSymbol[IconSymbol["Mute"] = 93] = "Mute";
    IconSymbol[IconSymbol["NanoWave"] = 94] = "NanoWave";
    IconSymbol[IconSymbol["NeuralAmp"] = 95] = "NeuralAmp";
    IconSymbol[IconSymbol["New"] = 96] = "New";
    IconSymbol[IconSymbol["NoAudio"] = 97] = "NoAudio";
    IconSymbol[IconSymbol["Note"] = 98] = "Note";
    IconSymbol[IconSymbol["NotePad"] = 99] = "NotePad";
    IconSymbol[IconSymbol["OpenDAW"] = 100] = "OpenDAW";
    IconSymbol[IconSymbol["Panel"] = 101] = "Panel";
    IconSymbol[IconSymbol["Paste"] = 102] = "Paste";
    IconSymbol[IconSymbol["Peak"] = 103] = "Peak";
    IconSymbol[IconSymbol["Pencil"] = 104] = "Pencil";
    IconSymbol[IconSymbol["Piano"] = 105] = "Piano";
    IconSymbol[IconSymbol["Play"] = 106] = "Play";
    IconSymbol[IconSymbol["Playfield"] = 107] = "Playfield";
    IconSymbol[IconSymbol["PlayOnce"] = 108] = "PlayOnce";
    IconSymbol[IconSymbol["PlayRepeat"] = 109] = "PlayRepeat";
    IconSymbol[IconSymbol["PlayAlternate"] = 110] = "PlayAlternate";
    IconSymbol[IconSymbol["Pointer"] = 111] = "Pointer";
    IconSymbol[IconSymbol["Popout"] = 112] = "Popout";
    IconSymbol[IconSymbol["Primary"] = 113] = "Primary";
    IconSymbol[IconSymbol["Random"] = 114] = "Random";
    IconSymbol[IconSymbol["Record"] = 115] = "Record";
    IconSymbol[IconSymbol["Rectangle"] = 116] = "Rectangle";
    IconSymbol[IconSymbol["Redo"] = 117] = "Redo";
    IconSymbol[IconSymbol["Region"] = 118] = "Region";
    IconSymbol[IconSymbol["Robot"] = 119] = "Robot";
    IconSymbol[IconSymbol["RoundDown"] = 120] = "RoundDown";
    IconSymbol[IconSymbol["RoundUp"] = 121] = "RoundUp";
    IconSymbol[IconSymbol["Run"] = 122] = "Run";
    IconSymbol[IconSymbol["Sawtooth"] = 123] = "Sawtooth";
    IconSymbol[IconSymbol["Saxophone"] = 124] = "Saxophone";
    IconSymbol[IconSymbol["Scissors"] = 125] = "Scissors";
    IconSymbol[IconSymbol["Search"] = 126] = "Search";
    IconSymbol[IconSymbol["SelectDown"] = 127] = "SelectDown";
    IconSymbol[IconSymbol["SelectUp"] = 128] = "SelectUp";
    IconSymbol[IconSymbol["Shadertoy"] = 129] = "Shadertoy";
    IconSymbol[IconSymbol["Shutdown"] = 130] = "Shutdown";
    IconSymbol[IconSymbol["Sine"] = 131] = "Sine";
    IconSymbol[IconSymbol["Solo"] = 132] = "Solo";
    IconSymbol[IconSymbol["SoundFont"] = 133] = "SoundFont";
    IconSymbol[IconSymbol["Speaker"] = 134] = "Speaker";
    IconSymbol[IconSymbol["SpeakerHeadphone"] = 135] = "SpeakerHeadphone";
    IconSymbol[IconSymbol["Square"] = 136] = "Square";
    IconSymbol[IconSymbol["Stack"] = 137] = "Stack";
    IconSymbol[IconSymbol["Start"] = 138] = "Start";
    IconSymbol[IconSymbol["Stereo"] = 139] = "Stereo";
    IconSymbol[IconSymbol["Stop"] = 140] = "Stop";
    IconSymbol[IconSymbol["Subtract"] = 141] = "Subtract";
    IconSymbol[IconSymbol["Sun"] = 142] = "Sun";
    IconSymbol[IconSymbol["Swap"] = 143] = "Swap";
    IconSymbol[IconSymbol["System"] = 144] = "System";
    IconSymbol[IconSymbol["Table"] = 145] = "Table";
    IconSymbol[IconSymbol["Tape"] = 146] = "Tape";
    IconSymbol[IconSymbol["TapeReel"] = 147] = "TapeReel";
    IconSymbol[IconSymbol["Time"] = 148] = "Time";
    IconSymbol[IconSymbol["Timeline"] = 149] = "Timeline";
    IconSymbol[IconSymbol["Tone3000"] = 150] = "Tone3000";
    IconSymbol[IconSymbol["Tool"] = 151] = "Tool";
    IconSymbol[IconSymbol["Triangle"] = 152] = "Triangle";
    IconSymbol[IconSymbol["Undo"] = 153] = "Undo";
    IconSymbol[IconSymbol["Unknown"] = 154] = "Unknown";
    IconSymbol[IconSymbol["UserFolder"] = 155] = "UserFolder";
    IconSymbol[IconSymbol["Velocity"] = 156] = "Velocity";
    IconSymbol[IconSymbol["Vinyl"] = 157] = "Vinyl";
    IconSymbol[IconSymbol["Vocoder"] = 158] = "Vocoder";
    IconSymbol[IconSymbol["Volume"] = 159] = "Volume";
    IconSymbol[IconSymbol["VUMeter"] = 160] = "VUMeter";
    IconSymbol[IconSymbol["Waveform"] = 161] = "Waveform";
    IconSymbol[IconSymbol["Zeitgeist"] = 162] = "Zeitgeist";
})(IconSymbol || (IconSymbol = {}));
(function (IconSymbol) {
    IconSymbol.toName = (symbol) => IconSymbol[symbol];
    IconSymbol.fromName = (name) => IconSymbol[name] ?? IconSymbol.Rectangle;
})(IconSymbol || (IconSymbol = {}));
